import './assets/style/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 引入 core-js 来填充现代 JavaScript 特性
import 'core-js/stable';  // 全部 Polyfill，确保现代 JavaScript 特性被支持

// 如果使用了 async/await，还需要引入 regenerator-runtime
import 'regenerator-runtime/runtime';



import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.mount('#app')
